// extracted by mini-css-extract-plugin
module.exports = {"ui_checkbox":"Checkbox_ui_checkbox__25cbr","checkbox":"Checkbox_checkbox__Z7YsJ","disabled":"Checkbox_disabled__16hgi"};